import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { NotificationManager, SiteConfigManager, StorageManager } from '@atlas/core';
import { BasePopup, Button } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';

const DEMO_POPUP_ACCEPTED_KEY = 'demoPopupAcceptedKey';

export const DemoPopup = ({ id }) => {
  const contentRef = useRef(null);
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    const contentNode = contentRef.current;
    if (!contentNode) return;

    const observer = new MutationObserver(() => {
      const contentHeight = contentNode.clientHeight;
      const containerHeight = contentNode.parentNode.clientHeight;

      setShowShadow(contentHeight > containerHeight || contentHeight > 500);
    });

    observer.observe(contentNode, { attributes: true, childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  const onClickDemoPopup = () => {
    StorageManager.setItem(DEMO_POPUP_ACCEPTED_KEY, 'true');
    NotificationManager.removeNotification(id);
  };

  const footerClassName = cx('demo-popup-footer', { 'show-shadow': showShadow });

  return (
    <BasePopup>
      <div className="popup__window demo-popup">
        <div className="demo-popup-content" ref={contentRef}>
          <StaticBlock
            options={{
              source: SiteConfigManager.getConfig('config.config.general.demoPopupStaticBlock'),
            }}
          />
        </div>
        <div className={footerClassName}>
          <Button label="Ok" onClick={onClickDemoPopup} />
        </div>
      </div>
    </BasePopup>
  );
};

DemoPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
